export default {
  type: 'Polygon',
  coordinates: [
    [
      [
        55.9080791832404,
        37.540631241388915,
      ],
      [
        55.90991119118755,
        37.54329199273169,
      ],
      [
        55.90991119118755,
        37.54500860650123,
      ],
      [
        55.908561299021486,
        37.54638189751685,
      ],
      [
        55.91097178764269,
        37.572388596125265,
      ],
      [
        55.91126103616557,
        37.58097166497292,
      ],
      [
        55.910393284096635,
        37.587237305231696,
      ],
      [
        55.91208056188035,
        37.5894689031321,
      ],
      [
        55.911405659614466,
        37.59024137932838,
      ],
      [
        55.90913983001369,
        37.59230131585182,
      ],
      [
        55.902968385901886,
        37.61530394036354,
      ],
      [
        55.89867672240136,
        37.63573164422096,
      ],
      [
        55.8963136928996,
        37.6564168401438,
      ],
      [
        55.895590287625424,
        37.66920561272682,
      ],
      [
        55.897567563287964,
        37.672295517511984,
      ],
      [
        55.89544560494516,
        37.677445358820556,
      ],
      [
        55.89510800991749,
        37.68525595147193,
      ],
      [
        55.89472218341663,
        37.695126480646735,
      ],
      [
        55.8937093705203,
        37.70147795159401,
      ],
      [
        55.892117753756565,
        37.70705694634497,
      ],
      [
        55.88468934195354,
        37.722077316828376,
      ],
      [
        55.883869234955306,
        37.724909729548116,
      ],
      [
        55.88425516982795,
        37.728171295710226,
      ],
      [
        55.8834350536174,
        37.73014540154519,
      ],
      [
        55.880878109031855,
        37.72988790947974,
      ],
      [
        55.83057325396261,
        37.8278207250315,
      ],
      [
        55.830283401285506,
        37.829966492243415,
      ],
      [
        55.82902734795072,
        37.830481476374274,
      ],
      [
        55.825693778139104,
        37.834773010798116,
      ],
      [
        55.821731771369,
        37.837948746271756,
      ],
      [
        55.81627126879625,
        37.839322037287374,
      ],
      [
        55.81515974480911,
        37.84155363518776,
      ],
      [
        55.81293660118471,
        37.842154450007094,
      ],
      [
        55.811438323763554,
        37.83992285210672,
      ],
      [
        55.779283905883084,
        37.8431844182688,
      ],
      [
        55.777784327694,
        37.84721846062722,
      ],
      [
        55.77473661926786,
        37.84387106377664,
      ],
      [
        55.772511157168424,
        37.84387106377664,
      ],
      [
        55.76815662310663,
        37.84627432305396,
      ],
      [
        55.76665661492899,
        37.843785233088134,
      ],
      [
        55.747829004347075,
        37.84275526482643,
      ],
      [
        55.74618296963533,
        37.84335607964577,
      ],
      [
        55.742309671676956,
        37.84472937066139,
      ],
      [
        55.74066340312013,
        37.84232611138404,
      ],
      [
        55.73373862766509,
        37.84138197381081,
      ],
      [
        55.73097805854946,
        37.84335607964577,
      ],
      [
        55.72923444019977,
        37.84112448174537,
      ],
      [
        55.719740034922566,
        37.83975119072974,
      ],
      [
        55.71852884712405,
        37.84121031243384,
      ],
      [
        55.71712382202094,
        37.83949369866432,
      ],
      [
        55.71407135119794,
        37.83897871453346,
      ],
      [
        55.708983367469585,
        37.8365754552561,
      ],
      [
        55.708062613595054,
        37.838892883844984,
      ],
      [
        55.70660874732137,
        37.84000868279519,
      ],
      [
        55.70505789674864,
        37.834429688044196,
      ],
      [
        55.69861151168543,
        37.83108229119362,
      ],
      [
        55.6924549442703,
        37.83005232293191,
      ],
      [
        55.69022476623574,
        37.83056730706275,
      ],
      [
        55.68455178114655,
        37.83734793145241,
      ],
      [
        55.68324251336023,
        37.832798904963155,
      ],
      [
        55.66422892540464,
        37.83992285210672,
      ],
      [
        55.6618030554939,
        37.840437836237555,
      ],
      [
        55.65835806076342,
        37.84035200554908,
      ],
      [
        55.65772725409982,
        37.84232611138404,
      ],
      [
        55.655300979485304,
        37.84112448174537,
      ],
      [
        55.65505834371793,
        37.839322037287374,
      ],
      [
        55.65073917436908,
        37.83580297905982,
      ],
      [
        55.64161396272205,
        37.822842545099874,
      ],
      [
        55.640351797287266,
        37.82447332818092,
      ],
      [
        55.63894394919426,
        37.82181257683815,
      ],
      [
        55.63884685434928,
        37.81777853447975,
      ],
      [
        55.62573683147219,
        37.79838079888404,
      ],
      [
        55.61825728992302,
        37.78421873528542,
      ],
      [
        55.61655719422069,
        37.78833860833229,
      ],
      [
        55.616168590521646,
        37.78722280938208,
      ],
      [
        55.61631431736208,
        37.780528015680915,
      ],
      [
        55.60144737748515,
        37.753920502253195,
      ],
      [
        55.592796684279925,
        37.73357862908425,
      ],
      [
        55.58958863706433,
        37.73194784600318,
      ],
      [
        55.58963724580534,
        37.72636885125221,
      ],
      [
        55.587012287267264,
        37.7194165654856,
      ],
      [
        55.57709418597993,
        37.692723221369405,
      ],
      [
        55.57252323351391,
        37.69143576104226,
      ],
      [
        55.573836221369326,
        37.68456930596412,
      ],
      [
        55.57203693052735,
        37.67650122124733,
      ],
      [
        55.57140472760339,
        37.66748899895728,
      ],
      [
        55.572717753015176,
        37.644143051691664,
      ],
      [
        55.57203693052735,
        37.64173979241431,
      ],
      [
        55.5722314524477,
        37.640366501398695,
      ],
      [
        55.57325267665427,
        37.63830656487526,
      ],
      [
        55.57490603072885,
        37.60757917840064,
      ],
      [
        55.57198829989606,
        37.601313538141866,
      ],
      [
        55.572085561098156,
        37.59479040581765,
      ],
      [
        55.576121687653604,
        37.59101385552467,
      ],
      [
        55.59060940792839,
        37.53041738946022,
      ],
      [
        55.589394201495665,
        37.529044098444594,
      ],
      [
        55.58963724580534,
        37.527670807428976,
      ],
      [
        55.5917273644714,
        37.526125855036376,
      ],
      [
        55.59396318160607,
        37.51711363274636,
      ],
      [
        55.595810064485015,
        37.51127714592995,
      ],
      [
        55.59819144248995,
        37.50664228875222,
      ],
      [
        55.60863863031263,
        37.49411100823464,
      ],
      [
        55.60859004520949,
        37.49290937859596,
      ],
      [
        55.60965890351535,
        37.48964781243385,
      ],
      [
        55.61276814315014,
        37.489046997614516,
      ],
      [
        55.63675798675876,
        37.460609177881096,
      ],
      [
        55.63690363673478,
        37.45588849001489,
      ],
      [
        55.640787435494936,
        37.456231812768806,
      ],
      [
        55.65918167714661,
        37.43443081789574,
      ],
      [
        55.66126807468161,
        37.42833683901391,
      ],
      [
        55.66409074426414,
        37.429850046311785,
      ],
      [
        55.66772927890977,
        37.42736095634596,
      ],
      [
        55.66802034700477,
        37.426245157395755,
      ],
      [
        55.66947565486582,
        37.42521518913405,
      ],
      [
        55.67151299455388,
        37.42495769706863,
      ],
      [
        55.68063120939673,
        37.4177479192366,
      ],
      [
        55.682134539835985,
        37.415001337205325,
      ],
      [
        55.684074235302056,
        37.41448635307449,
      ],
      [
        55.68601383415551,
        37.4147438451399,
      ],
      [
        55.69192901398237,
        37.410967294846934,
      ],
      [
        55.70002456548066,
        37.400925104295176,
      ],
      [
        55.70021845025869,
        37.39895099846022,
      ],
      [
        55.70322354080471,
        37.39508861747877,
      ],
      [
        55.70444126344165,
        37.39523882118353,
      ],
      [
        55.70932388786408,
        37.388340179597215,
      ],
      [
        55.71114108539722,
        37.386666481171936,
      ],
      [
        55.712933970438975,
        37.3820316239942,
      ],
      [
        55.71545356109932,
        37.383962814484924,
      ],
      [
        55.72146115715548,
        37.38121623245368,
      ],
      [
        55.72155804626163,
        37.379842941438056,
      ],
      [
        55.72589358665206,
        37.37924212661872,
      ],
      [
        55.73148789920479,
        37.37615222183355,
      ],
      [
        55.732626037401566,
        37.37340563980231,
      ],
      [
        55.735507557455975,
        37.37379187790044,
      ],
      [
        55.741923620329786,
        37.371002380524956,
      ],
      [
        55.74681364360561,
        37.369028274689995,
      ],
      [
        55.75114636775149,
        37.36851329055913,
      ],
      [
        55.762273857864535,
        37.36877078262457,
      ],
      [
        55.76295136456614,
        37.36804122177253,
      ],
      [
        55.76454829787404,
        37.3664533540357,
      ],
      [
        55.765999998429734,
        37.367139999543504,
      ],
      [
        55.7672580950035,
        37.36889952865729,
      ],
      [
        55.78331943652299,
        37.36932868209968,
      ],
      [
        55.78750768386658,
        37.370612736008106,
      ],
      [
        55.78920032754117,
        37.36953985240214,
      ],
      [
        55.79137647516702,
        37.37194311167949,
      ],
      [
        55.79239196894375,
        37.37456094767803,
      ],
      [
        55.80119180130762,
        37.38335859324687,
      ],
      [
        55.806775274597115,
        37.38717805888408,
      ],
      [
        55.809989636866625,
        37.388336773178516,
      ],
      [
        55.8212498858535,
        37.39185583140605,
      ],
      [
        55.82844893080718,
        37.3937011912083,
      ],
      [
        55.83098000861329,
        37.39446957720582,
      ],
      [
        55.83209107877716,
        37.39309628619019,
      ],
      [
        55.83349194789854,
        37.39331086291138,
      ],
      [
        55.83349194789854,
        37.39519913805787,
      ],
      [
        55.83612447862834,
        37.395585376156,
      ],
      [
        55.84039894084628,
        37.394555407894295,
      ],
      [
        55.84406928884544,
        37.392109233272706,
      ],
      [
        55.84602505584803,
        37.391465503109124,
      ],
      [
        55.84843944670971,
        37.39150841845336,
      ],
      [
        55.859954018665725,
        37.39760239733519,
      ],
      [
        55.86545662897528,
        37.40279515398803,
      ],
      [
        55.87045174201623,
        37.410262423885506,
      ],
      [
        55.87182709464459,
        37.410777408016344,
      ],
      [
        55.87192360878175,
        37.41339524401488,
      ],
      [
        55.87583222890434,
        37.42498238695923,
      ],
      [
        55.877400391343826,
        37.424145537746575,
      ],
      [
        55.87760545403715,
        37.42554028643433,
      ],
      [
        55.87789495245842,
        37.42989619387451,
      ],
      [
        55.87779845322553,
        37.43172009600463,
      ],
      [
        55.8790770485136,
        37.435153323543716,
      ],
      [
        55.88095867787652,
        37.44088252199952,
      ],
      [
        55.88322616080124,
        37.44304974688356,
      ],
      [
        55.882791972239694,
        37.445946532619615,
      ],
      [
        55.88284021565405,
        37.453885871303726,
      ],
      [
        55.883021127921616,
        37.46240456713501,
      ],
      [
        55.88344325325308,
        37.46669610155885,
      ],
      [
        55.8845166369019,
        37.47081597460572,
      ],
      [
        55.88598796829932,
        37.47665246142213,
      ],
      [
        55.889666051751895,
        37.48326142443477,
      ],
      [
        55.890051928742295,
        37.4853213609582,
      ],
      [
        55.88831545194136,
        37.48660882128536,
      ],
      [
        55.89101660436062,
        37.4930461229211,
      ],
      [
        55.89275295978699,
        37.4945052446252,
      ],
      [
        55.89386225712771,
        37.49699433459102,
      ],
      [
        55.89371756797631,
        37.49991257799922,
      ],
      [
        55.903989151354715,
        37.522571879757045,
      ],
      [
        55.907171341275266,
        37.53338654650508,
      ],
      [
        55.9080791832404,
        37.540631241388915,
      ],
    ],
  ],
};
